import { render, staticRenderFns } from "./CertificatesTrainingView.vue?vue&type=template&id=60600d3d&scoped=true"
import script from "./CertificatesTrainingView.vue?vue&type=script&lang=js"
export * from "./CertificatesTrainingView.vue?vue&type=script&lang=js"
import style0 from "./CertificatesTrainingView.vue?vue&type=style&index=0&id=60600d3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60600d3d",
  null
  
)

export default component.exports